// extracted by mini-css-extract-plugin
export var breakWhitespace = "Shape-module--breakWhitespace--at6mQ";
export var root = "Shape-module--root--CT87B";